import type {
  DerivedEventLegacy,
  SimpleEventLegacy,
  SubjectVariableLegacy,
} from '@verantos-dev/types-cohorts';

import { validateForDuplicateNames } from './validateForDuplicateNames';

export const isNameUnique = (
  activeEditModalItemId: string,
  name: string,
  subjectVariables: SubjectVariableLegacy[],
  derivedEvents: DerivedEventLegacy[],
  simpleEvents: SimpleEventLegacy[]
) => {
  const formattedNameToCheck = name.trim().toLowerCase();

  const { names } = validateForDuplicateNames(
    subjectVariables
      ? subjectVariables.filter((variable) => variable.id !== activeEditModalItemId)
      : [],
    derivedEvents ? derivedEvents.filter((event) => event.id !== activeEditModalItemId) : [],
    simpleEvents ? simpleEvents.filter((event) => event.id !== activeEditModalItemId) : []
  );

  return names[formattedNameToCheck] === undefined;
};
